<footer class="footer">
  <div class="footer__container">
    <div class="footer__line"></div>

    <div class="footer__grid">
      <div class="footer__top">
        <div class="footer__logo">
          <ui-icon iconName="logo-riddicks-partners" size="full" />
        </div>

        <div class="footer__rights">{{ 'footer.rightsReserved' | translate }}</div>
      </div>

      <div class="footer__privacy">
        <div class="footer__privacy_email">
          <ui-icon iconName="mail" size="s" />
          <a href="mailto:{{ email }}">{{ email }}</a>
        </div>

        <div class="footer__privacy_links">
          <p class="footer__privacy_link" (click)="navigateToPage(linkToWebmasterTermsAndConditions)">
            {{ 'footer.webmasterTermsConditions' | translate }}
          </p>

          <p class="footer__privacy_link" (click)="navigateToPage(linkToAdvertiserTermsAndConditions)">
            {{ 'footer.advertiserTermsConditions' | translate }}
          </p>

          <p class="footer__privacy_link" (click)="navigateToPage(linkToPrivacyPolicy)">
            {{ 'footer.privacyPolicy' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
